import { Contact } from "../components/Contact";
import { Process } from "../components/Process";
import { Faq } from "../components/Faq";
import { useTitle } from "../components/Reveal";

export default function Kontakt() {
  useTitle("Kontakt – Manfred Berglar · Malermeister seit 1925");
  return (
    <div className="bg-white text-ink overflow-x-clip">
      <h1 className="sr-only">Kontakt – Manfred Berglar, Malermeister, Olpe-Griesemert</h1>
      <div className="pt-[76px] md:pt-[88px]">
        <Contact />
        <Process />
        <section className="bg-surface border-t border-line py-20 md:py-28" data-testid="kontakt-faq-section">
          <div className="container-x">
            <Faq />
          </div>
        </section>
      </div>
    </div>
  );
}
